export default __webpack_public_path__ + "static/media/eu-loginImg.d0f52d75.jpg";